// extracted by mini-css-extract-plugin
module.exports = {"btn":"ViewSdsDetails_btn__2k6SA","view-details":"ViewSdsDetails_view-details__cif3N","container":"ViewSdsDetails_container__p-w7b"};